import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFiftyTwoPreLogin',
    name: 'IFPageOneHFiftyTwoPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFiftyTwoLogin' ||
        from.path === '/IFPageOneHFiftyTwoLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFiftyTwoLogin',
    name: 'pageOneHFiftyTwoLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/login.vue'),
  },
  {
    path: '/IFPageOneHFiftyTwoLeaveInfo',
    name: 'pageOneHFiftyTwoLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFiftyTwoResult',
    name: 'pageOneHFiftyTwoResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/result.vue'),
  },
  {
    path: '/IFPageOneHFiftyTwoLoading',
    name: 'pageOneHFiftyTwoLoading',
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFiftyTwoLoginSecond',
    name: 'pageOneHFiftyTwoLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftyTwoOnline',
    name: 'pageOneHFiftyTwoOnline',
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFiftyTwoLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFiftyTwoGuide',
    name: 'pageOneHFiftyTwoLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHFiftyTwoCar',
    name: 'pageOneHFiftyTwoCar',
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFiftyTwoCarDetails',
    name: 'pageOneHFiftyTwoCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHFiftyTwoBlank',
    name: 'pageOneHFiftyTwoBlank',
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftyTwoOnlineTab',
    name: 'pageOneHFiftyTwoOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFiftyTwo/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
];
